module.exports = __webpack_public_path__ + "img/IMG_9928_L_WoodMatted_MockedUp.4b39eacb.jpg";